import styled from 'styled-components';
import media from 'styled-media-query';

export const FooterWrapper = styled.footer`
    grid-area: ft;
`